<template>
  <b-form-group
    label="Services"
    label-for="services"
  >
    <v-select
      id="services"
      v-model="service"
      label="label"
      :options="services"
      :loading="loadingServices"
      @input="onServiceSelected"
    />
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import { ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'

export default {
  components: {
    vSelect,
    BFormGroup,
  },
  props: {
    selectedZone: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const service = ref(null)
    const formatServices = services => services.map(el => {
      const serviceData = el.split('::')
      const [serviceName, serviceClass] = serviceData
      return {
        service: serviceName,
        class: serviceClass,
        label: `${serviceName} - ${serviceClass}`,
      }
    })

    const services = ref([])
    const loadingServices = ref(false)
    const fetchZoneServices = () => {
      loadingServices.value = true
      ctx.root.$store.dispatch('zones/fetchZonesServices', props.selectedZone).then(result => {
        services.value = formatServices(result)
        loadingServices.value = false
      })
    }

    const onServiceSelected = event => {
      if (!event) {
        ctx.emit('service-selected', null)
        return
      }

      ctx.emit('service-selected', `${event.service}::${event.class}`)
    }
    watch(loadingServices, () => {
      ctx.emit('services-loading-state', loadingServices.value)
    }, { immediate: true })

    watch(() => props.selectedZone, v => {
      if (v) {
        fetchZoneServices()
        service.value = null
      }
    })
    fetchZoneServices()
    return {
      service,
      loadingServices,
      services,
      onServiceSelected,
    }
  },
}
</script>

<style>

</style>
